import {initializeVueComponent} from "../utils/vue";
import TgCompleteLogin from '@topgeschenken/webshop-front/components/auth/TgCompleteLogin'

import './../scss/customer-account-resetting.scss';

(function() {
  initializeVueComponent('#customer_login_app', TgCompleteLogin)
})()
